import DeleteBidGroupVendorContainer from "./DeleteBidGroupVendorContainer";
export default DeleteBidGroupVendorContainer;
